module.exports = __webpack_public_path__ + "static/media/nd3.7a86e096.webp";